export default {
  label: {
    title: 'Criar componente',
    data: {
      title: 'Dados',
    },
    details: {
      title: 'Detalhes',
      titleInput: 'Título',
      descriptionInput: 'Descrição',
    },
    sensitiveData: {
      label: 'Dados sensíveis (LGPD)',
    },
    viewControl: {
      title: 'Controle de visualização',
      featureFlag: 'Feature Flag',
    },
    button: {
      apply: 'Aplicar',
      cancel: 'Cancelar',
      clearAll: 'Limpar Tudo',
    },
  },
  errorMessage: {
    default: 'Campo obrigatório.',
    invalidValues: 'Valores inválidos.',
    details: {
      title: 'O título deve ter no máximo 50 caracteres.',
      description: 'A descrição deve ter no máximo 200 caracteres.',
    },
  },
  message: {
    createComponent: 'Componente criado com sucesso.',
  },
};

